<template>
  <section v-if="embedUrl" class="sectionSize bg-secondary">
    <div class="w-full max-w-3xl aspect-video rounded-2xl overflow-hidden shadow-2xl">
      <iframe
        :src="embedUrl"
        class="w-full h-full"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        loading="lazy"
        :title="title"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ videoId?: string | null; title?: string }>()

function extractYoutubeId(url: string): string {
  const trimmed = url.trim()
  const embedMatch = trimmed.match(/youtube\.com\/embed\/([^?&]+)/)
  if (embedMatch) return embedMatch[1]
  const shortsMatch = trimmed.match(/youtube\.com\/shorts\/([^?&]+)/)
  if (shortsMatch) return shortsMatch[1]
  const watchMatch = trimmed.match(/[?&]v=([^&]+)/)
  if (watchMatch) return watchMatch[1]
  const shortMatch = trimmed.match(/youtu\.be\/([^?]+)/)
  if (shortMatch) return shortMatch[1]
  return trimmed
}

const embedUrl = computed(() => {
  if (!props.videoId) return null
  const id = extractYoutubeId(props.videoId)
  return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`
})
</script>
